export enum ConsoleStatus {
  UP = 'UP',
  DOWN = 'DOWN',
}
